import React from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { GuideMythCard, GuideMythItem } from './GuideMythCard';
import { GUIDE_TEXT_MAX_WIDTH } from './guidePage.constants';

type GuideMythsAndMistakesSectionProps = Readonly<{
  intro: string;
  mythLabel: string;
  mistakeLabel: string;
  items: readonly GuideMythItem[];
}>;

export const GuideMythsAndMistakesSection: React.FC<GuideMythsAndMistakesSectionProps> = ({
  intro,
  mythLabel,
  mistakeLabel,
  items,
}) => {
  const myths = items.filter((item) => item.type === 'myth');
  const mistakes = items.filter((item) => item.type === 'mistake');

  return (
    <Box sx={containerSx}>
      <Typography variant="text-md-regular" sx={introSx}>
        {intro}
      </Typography>

      <Box sx={gridSx}>
        <Box sx={columnSx}>
          {myths.map((item) => (
            <GuideMythCard
              key={item.title}
              type={item.type}
              label={mythLabel}
              title={item.title}
              body={item.body}
            />
          ))}
        </Box>
        <Box sx={columnSx}>
          {mistakes.map((item) => (
            <GuideMythCard
              key={item.title}
              type={item.type}
              label={mistakeLabel}
              title={item.title}
              body={item.body}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

const introSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  mb: backrs.spacing['spacing-3xl'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});

const gridSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: backrs.spacing['spacing-xl'],
  '@container (min-width: 720px)': {
    gridTemplateColumns: '1fr 1fr',
  },
});

const columnSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
});
